<template>
  <div class="ContactUs">
    <div class="cs-contactUs-part1">
        <img src="../assets/img/cs-contactUs-1.jpg" alt="" />
        <div class="con">
            <div class="item1">
                <p class="more">更多业务咨询</p>
                <p class="url">edu@jschuangsen.cn</p>
                <p class="tel">服务热线：13681163410</p>
            </div>
            <div class="item2">
                <p class="more">关注我们</p>
                <img src="../assets/img/cs-contactUs-4.jpg" alt="" />
            </div>
        </div>
    </div>
    <!-- <div class="cs-contactUs-part2" s>
        <div class="container">
          <el-row justify="space-between" :gutter="60"  style="margin-bottom:60px">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-2.jpg" class="image">
                <div class="address-desc">
                  <p class="address">汉口学院 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>湖北省武汉市江夏区大桥新区街道金樱街文化大道汉口学院北门梧桐雨 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">万茫</p>
                      <p class="telnum">135 4535 5810</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-3.jpg" class="image">
                <div class="address-desc">
                  <p class="address">武汉大学 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>湖北省武汉市武昌区珞珈山街办事处东湖南路8号武汉大学工程创新与实践中心1104室 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">刁君梅</p>
                      <p class="telnum">159 7298 9438</p>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row justify="space-between" :gutter="60"  style="margin-bottom:60px">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-adr-3.jpg" class="image">
                <div class="address-desc">
                  <p class="address">湖北汽车工业学院 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>湖北省十堰市张湾区车城西路167号湖北汽车工业学院逸夫图书馆一层 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">张驰</p>
                      <p class="telnum">133 1717 9543</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-adr-4.jpg" class="image">
                <div class="address-desc">
                  <p class="address">中南财经政法大学 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>湖北省武汉市东湖高新技术开发区南湖大道182号中南财经政法大学图书馆2楼 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">赵艳</p>
                      <p class="telnum">136 5720 2629</p>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row justify="space-between" :gutter="60"  style="margin-bottom:60px">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-adr-5.jpg" class="image">
                <div class="address-desc">
                  <p class="address">烟台大学 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>山东省烟台市莱山区清泉路30号烟台大学北校区天猫校园2层 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">卢炳旭</p>
                      <p class="telnum">156 1565 2512</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-adr-6.jpg" class="image">
                <div class="address-desc">
                  <p class="address">兰州大学 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>甘肃省兰州市榆中夏官营镇兰州大学榆中校区综合体天猫超市负一楼 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">王宁</p>
                      <p class="telnum">151 7029 9007</p>
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row justify="space-between" :gutter="60"  style="margin-bottom:60px">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-card :body-style="{ padding: '0px' ,textAlign: 'center'}">
                <img src="../assets/img/cs-contactUs-adr-7.jpg" class="image">
                <div class="address-desc">
                  <p class="address">兰州财经大学 Apple 校园体验中心</p>
                  <div class="address-con">
                    <p>甘肃省兰州市榆中县薇乐大道4号财经大学和平校区天猫超市4楼 Apple 校园体验中心</p>
                  </div>
                  <div class="tel">
                      <p class="name">李雨姿</p>
                      <p class="telnum">173 1877 8101</p>
                  </div>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            </el-col>
          </el-row>
        </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name:'ContactUs',
  data() {
    return {
    }
  },
  mounted(){
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
.ContactUs{
    border-bottom: 1px solid #D6D6D6;
    .cs-contactUs-part1{
        height: 750px;
        position: relative;
        text-align: center;
        margin-bottom: 400px;
        img{
          max-height: 100%;
        }
        .con{
            position: absolute;
            left: 50%;
            bottom: -245px;
            width: 1200px;
            height: 320px;
            margin: 0 0 0 -600px;
            background: #FFFFFF;
            border-radius: 22px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            .item1{
                width: 759px;
                position: relative;
                &::after{
                    position: absolute;
                    right: 0;
                    top: 80px;
                    content: '';
                    width: 2px;
                    height: 160px;
                    background: #CECECE;
                }
            }
            .item2{
                width: 448px;
                p{
                    margin-bottom: 10px;
                }
            }
            .item1,.item2{
                display: table-cell;
                vertical-align: middle;
                height: 320px;
                text-align: center;
                p{
                    width: 100%;
                    text-align: center;
                }
                p.more{
                    font-size: 24px;
                    font-weight: 600;
                    color: #000000;
                }
                p.url{
                    font-size: 34px;
                    font-weight: 600;
                    color: #000000;
                    margin-top: 10px;
                }
                p.tel{
                    font-size: 24px;
                    font-weight: 600;
                    color: #000000;
                    margin-top: 10px;
                }
            }
        }
    }

    .cs-contactUs-part2{
        width: 100%;
        background: #F5F5F7;
        padding: 330px 0 100px 0;
        .el-card{
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            border-radius: 22px;
        }
        .address-desc{
            padding: 30px 0 50px 0;
            .address{
                font-size: 24px;
                font-weight: 600;
                color: #000000;
                text-align: left;
                padding-left: 105px;
                background: url(../assets/img/icon-address1.png) no-repeat 65px 3px;
            }
            .address-con{
                padding: 15px 60px 15px 105px;
                text-align: left;
                p{
                    font-size: 17px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                }
            }
            .tel{
                font-size: 17px;
                font-weight: 600;
                color: #000000;
                p{
                    float: left;
                    &.name{
                        padding-right: 60px;
                        text-align: right;
                        width: 239px;
                        border-right: 1px solid #CECECE;
                        background: url(../assets/img/icon-user.png) no-repeat 108px 0;
                    }
                    &.telnum{
                        padding-left: 95px;
                        background: url(../assets/img/icon-tel.png) no-repeat 58px 0;
                    }
                }
            }
        }
    }
}

// 适配
@media screen and (max-width: 1200px) {
  .ContactUs .cs-contactUs-part2 .el-card{
    padding-top: 30px;
    margin-bottom: 50px;
  }
  .ContactUs .cs-contactUs-part2 .img{
    max-width: 100%;
  }
}

// 适配
@media screen and (max-width: 768px) {
  .ContactUs .cs-contactUs-part2 .el-card{
    padding-top: 0;
  }
  .ContactUs .cs-contactUs-part1{
    height: auto;
    img{
      max-width: 100%;
    }
    
    .item2{
      img{
        max-width: 50%;
      }
    }
    .con{
      margin: 0;
      left: 10%;
      width: 80%;
      height: 200px;
      bottom: -135px;
      .item1{
        .url{
          font-size: 22px!important;
        }
        &::after{
          top: 42px;
          height: 120px;
        }
      }
      .item1,.item2{
        height: 200px;
      }
    }
    
  }
  .ContactUs .cs-contactUs-part2{
    padding: 200px 0 100px 0;
  }
  .ContactUs .cs-contactUs-part2 .address-desc{
      .address{
        padding-left:95px;
        background: url(../assets/img/icon-address1.png) no-repeat 45px 3px;
      }
      .address-con{
        padding: 15px 60px 15px 95px;
      }
      .tel{
        p{
          float: left;
          &.name{
              padding-right: 40px;
              text-align: right;
              width: 225px;
              background: url(../assets/img/icon-user.png) no-repeat 95px 0;
          }
          &.telnum{
              padding-left: 75px;
              background: url(../assets/img/icon-tel.png) no-repeat 28px 0;
              background-size: auto 100%;
          }
      }
      }
  }
}
</style>
